import { useEffect, useState } from 'react';

interface UseCountUpOptions {
  endValue: number;
  duration?: number;
  isVisible: boolean;
  suffix?: string;
}

export const useCountUp = ({ 
  endValue, 
  duration = 2000, 
  isVisible,
  suffix = ''
}: UseCountUpOptions) => {
  const [currentValue, setCurrentValue] = useState(0);

  useEffect(() => {
    if (!isVisible) return;

    let startTime: number | null = null;
    let animationFrame: number;

    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      
      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const value = Math.floor(easeOutQuart * endValue);
      
      setCurrentValue(value);

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [endValue, duration, isVisible]);

  return suffix ? `${currentValue}${suffix}` : currentValue.toString();
};
